export class LetterDashboardModel {
  outputRateToday = '0';
  outputRateChange = '0';
  answeredToday = '0';
  answeredTodayTarget = '0';
  answeredTotal = '0';
  answeredTotalTarget = '0';
}
